import Vue from "vue";
import Router from "vue-router";

import Layout from "@/components/Layout/Layout";

// Main
import DashboardPage from "@/pages/Dashboard/Dashboard";
import DevicesPage from "@/pages/Devices/Devices";
import DevicePage from "@/pages/Device/Device";
import UpgradesPage from "@/pages/Upgrades/Upgrades";
import DiagnosticPage from "@/pages/Diagnostic/Diagnostic";
import MainsOutage from "@/pages/MainsOutage/MainsOutage";

// Extra
import Login from "@/pages/Login/Login";
import ErrorPage from "@/pages/Error/Error";
import AccessDenied from "@/pages/AccessDenied/AccessDenied";

// Security
import { basePerimeter } from '@/_perimeters';


if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router)
}

export const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/error",
      name: "Error",
      component: ErrorPage
    },
    {
      path: "/app",
      name: "Layout",
      component: Layout,
      children: [
        // main pages
        {
          path: "main/dashboard",
          name: "DashboardPage",
          component: DashboardPage,
          meta: {
            perimeter: basePerimeter,
            perimeterAction: "view"
          }
        },
        {
          path: "main/mainsOutage",
          name: "MainsOutage",
          component: MainsOutage,
          beforeEnter: (to, from, next) => {
            if (Vue.prototype.$keycloak.hasResourceRole("VIEW_MAINS_SUPPLY")) {
              next();
            } else {
              next({ name: "AccessDenied" });
            }
          },
          meta: {
            perimeter: basePerimeter,
            perimeterAction: "viewMainsSupply",
          }
        },
        {
          path: "main/devices",
          name: "DevicesPage",
          component: DevicesPage,
          meta: {
            perimeter: basePerimeter,
            perimeterAction: 'view',
          }
        },
        {
          path: "main/device/:serial",
          name: "DevicePage",
          component: DevicePage,
          meta: {
            perimeter: basePerimeter,
            perimeterAction: 'view',
          },
        },
        {
          path: "main/diagnostic",
          name: "DiagnosticPage",
          component: DiagnosticPage,
          meta: {
            perimeter: basePerimeter,
            perimeterAction: 'view',
          },
        },
        {
          path: "main/upgrades",
          name: "UpgradesPage",
          component: UpgradesPage,
          meta: {
            perimeter: basePerimeter,
            perimeterAction: 'view',
          },
        },
        {
          path: "main/access-denied",
          name: "AccessDenied",
          component: AccessDenied,
        },
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const permission = to.meta && to.meta.permission;

  if (permission && !Vue.prototype.$base.isAllowed(permission)) {
    return next({
      name: "AccessDenied"
    });
  }

  next();
});